import React from 'react';
import { useStoreState } from "easy-peasy";
import AxiosWrapper from './axios';

class AdobeScript extends React.Component {

    constructor() {
        super();
        this.Setting    = useStoreState((state) => state.siteSettingsModel);
        this.Applicant  = useStoreState((state) => state.applicationResultModel.applicationResult);
        this.info       = useStoreState((state) => state.applicantModel.applicant);
        this.axios = new AxiosWrapper();
    }

    setup = () => {
        let adobeScript = document.createElement('script');

        adobeScript.setAttribute('src',process.env.REACT_APP_ADOBE_URL);
        adobeScript.setAttribute('async', "");
        document.head.appendChild(adobeScript);
        console.debug("Adobe Service Loaded!")
        return this
    }

    startEvent = (event, data = {}) => {
        if(typeof window.adobeDataLayer === 'undefined' ) return;

        window.adobeDataLayer.push({
            "event": event,
            campaign: {
                utm_channel:            this.axios.findParam('utm_channel') || undefined,
                utm_medium:             this.axios.findParam('utm_medium') || undefined,
                utm_name:               this.axios.findParam('utm_name') || undefined,
                utm_source:             this.axios.findParam('utm_source') || undefined,
                utm_source_platform:    this.axios.findParam('utm_source_platform') || undefined,
                utm_strategy:           this.axios.findParam('utm_strategy') || undefined,
            },
            cardType : this.Setting.brandSettings.ProductName,
            pageName: `cf | ${this.Setting.brandSettings.ProductName} | application | ${this.Setting.mainSettings.Flow}`,
            pageCleanUrl: window.location.origin + window.location.pathname,
            pageHostname: window.location.host,
            pageQuerystring: window.location.search === "" ? undefined : window.location.search,
            pageCategory: `cf | ${this.Setting.brandSettings.ProductName} | application`,
            pageSubcategory: undefined,
            siteSection: `cf | ${this.Setting.brandSettings.ProductName} | application`,
            pageType: 'application',
            userState: 'view',
            userType: 'viewer',
            ...data
        });
    }

    event = (event, data = null) => {
        if(typeof window.adobeDataLayer === 'undefined' ) return;

        let eventAttributes = {};
        switch (event) {
            case 'PayFee':
            case 'ApprovedPendfee':
                eventAttributes = {
                    applicant_id: this.Applicant?.ref_number || '',
                    cardType: this.Setting?.brandSettings?.ProductName ?? ""
                };
                break;
            case 'form_start':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? ""
                };
                break;
            case 'scroll':
                eventAttributes = {
                    scrollMilestone: '50%'
                };
                break;
            case 'form_checkpoint':
                eventAttributes = {
                    percentFilled: '50%'
                };
                break
            case 'prequal_offer':
                eventAttributes = {
                    applicant_id: this.Applicant?.ref_number || '',
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    creditLimit: this.Applicant?.credit_limit || ''
                };
                break;
            case 'prequal_accept':
                eventAttributes = {
                    applicant_id: this.Applicant?.ref_number || '',
                    chosen_color: data?.DisplayName || undefined,
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    creditLimit: this.Applicant?.credit_limit || ''
                };
                break;
            case 'apply_now_click':
                eventAttributes = {
                    chosen_color: data?.DisplayName || undefined,
                    cardType: this.Setting?.brandSettings?.ProductName
                };
                break;
            case 'see_my_card_offers':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? ""
                };
                break;
            case 'card_submit':
            case 'bankAccount_submit':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    applicant_id: this.Applicant?.ref_number ?? ""
                };
                break;
            case 'checkMoney_select':
            case 'moneyGram_select':
            case 'wUnion_select':
            case 'phonePay_select':
            case 'errorPayment':
            case 'approved':
                eventAttributes = {
                    applicant_id: this.Applicant?.ref_number || '',
                    cardType: this.Setting?.brandSettings?.ProductName ?? ""
                };
                break;
            case 'no_offer':
            case 'declined':
            case 'pendinfo':
                eventAttributes = {
                    applicant_id: this.Applicant?.ref_number || '',
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    reason: this.Applicant?.reason || 'N/A'
                };
                break;
            case 'sms_submit':
            case 'no_verif_code':
            case 'no_mobile':
            case 'sms_fail1':
            case 'sms_resend':
            case 'email_submit':
            case 'email_fail1':
            case 'email_resend':
            case 'final_timeout':
            case 'code_success':
            case 'code_failure':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    creditLimit: this.Applicant?.credit_limit || "" 
                };
                break;
            case 'form_submit':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? "",
                    chosen_color: data?.DisplayName || "",
                };
                break;
            case 'olp_yes':
                eventAttributes = {
                    cardType: this.Setting?.brandSettings?.ProductName ?? ""
                };
                break;
            case 'acknowledgment_checkpoint':
                eventAttributes = {
                    activeCheckingOrCard: this.info.HasCheckingAccount,
                    additionalCardInterest: this.info.hasAdditionalCardholder, 
                    chooseYourCard: this.Setting?.CardColors?.find(value => value.Code === this.info?.cardColorCode)?.DisplayName ?? "", 
                    creditProtectionProgram: this.info.creditProtection, 
                    acknowledge_paperless_statements: this.info.eConsentAcknowledgement,
                    acknowledge_sms: this.info.SMSConsent,
                };
                break;
            case "startRegistration":
            case "createUsername":
            case "createPassword":
            case "termsOfUse":
            case "registrationSuccess":
            case "registrationLogin":
                eventAttributes = {
                    reservationNumber: this.info?.ReservationCode ?? "",
                };
                break;
            case "app_download_click":
                eventAttributes = {
                    reservationNumber: this.info?.ReservationCode ?? "",
                    storeType: data ?? "",
                };
                break;
        }
        window.adobeDataLayer.push({event, ...eventAttributes});
    }
}

export default AdobeScript